
import axiosInstance from "api/axiosInstance";
export const adminSetting = async (accessToken) => {
    try {
      const response = await axiosInstance.get("/admin/settings/current", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status == 403) {
          console.warn(
            "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
          );
          window.location.href = "/login";
          return;
        }
        throw {
          statusCode: status,
          message:
            error.response.data?.message || "خطای ناشناخته   ",
        };
      } else {
        throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
      }
    }
  };
  export const adminSettingEdit = async ({accessToken,tokenFee,taxFee,zibal,zarinpal,ragSize,memorySize,ragRate,maxChunksPerGroup}) => {
    try {
      const response = await axiosInstance.patch("/admin/settings/edit",{tokenFee,taxFee,zibal,zarinpal,ragSize,memorySize,ragRate,maxChunksPerGroup}, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        if (status == 403) {
          console.warn(
            "خطای 403: دسترسی غیرمجاز، کاربر به صفحه ورود هدایت می‌شود."
          );
          window.location.href = "/login";
          return;
        }
        throw {
          statusCode: status,
          message:
            error.response.data?.message || "خطای ناشناخته   ",
        };
      } else {
        throw { statusCode: 500, message: "مشکل شبکه یا عدم دسترسی به سرور" };
      }
    }
  };